import React from "react";
import { default as ReactSelect, components } from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ReactSelectField = (props: any) => {
  const { infoText, ...restProps } = props;
  const getInfoText = () => {
    if (typeof infoText === "string") return infoText;
    if (infoText === true) {
      return "Field Type: Searchable Dropdown, Selection required";
    }
    return "";
  };

  const finalInfoText = getInfoText();

  return (
    <>
      <div className="form-floating position-relative">
        <ReactSelect
          className="form-select"
          {...restProps}
          styles={{
            control: (provided: any) => ({
              ...provided,
              minHeight: "36px",
              position: "absolute",
              width: "101%",
              top: "-1px",
              backgroundColor: props.isDisabled ? "#fbfbfb" : "#ffffff",
              left: "-1px",
            }),
          }}
        >
          {props?.children}
        </ReactSelect>
        <label htmlFor={props.id || "floatingSelect"}>
          {props?.placeholder}
          {finalInfoText && !props.isDisabled && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${props.name}`}>{finalInfoText}</Tooltip>}
            >
              <a className="ms-1 align-self-center">
                <img className=" pe-auto" 
                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
              </a>
            </OverlayTrigger>
          )}
        </label>
      </div>
    </>
  );
};

export default ReactSelectField;
